import * as Sentry from "@sentry/browser";
import { ApiError } from "@shared/svelte/Modules/ApiService";
import { ExtraErrorData as ExtraErrorDataIntegration } from "@sentry/integrations";

export default function initSentry() {
  if (window["C"].SENTRY_URL) {
    Sentry.init({
      dsn: window["C"].SENTRY_URL,
      environment: window["RAILS_ENV"],
      integrations: [new ExtraErrorDataIntegration()],
      tracesSampleRate: 0.0,
      ignoreErrors: window["C"].SKIP_ERRORS,
      denyUrls: window["C"].SENTRY_DENY_URLS,
      release: window["C"].GIT_REVISION,
      beforeSend: (event, hint) => {
        if (!(hint?.originalException instanceof ApiError)) return event;

        const exception = hint.originalException as ApiError;
        if ([400, 401, 422].includes(exception.status)) return;

        return event;
      },
    });
  }
}
